import Container from "react-bootstrap/Container"
import Row from "react-bootstrap/Row"
import Card from "react-bootstrap/Card"
import Col from "react-bootstrap/Col"
import EventCard from "./EventCard"
import { useTranslation } from "react-i18next"
import "../styles/MainPageBody.css"

// import boardImage from "../img/hallitus-yhteiskuva.png"
import sponsor_logo1 from "../img/kielikoulu_logo_lapinakyva.svg"
import sponsor_logo2 from "../img/biljardikauppa_logo.svg"
import Icon from "./Icon"

const MainPageBody = ({ upcomingEvents, news, loading, gameNights }) => {
    const { t } = useTranslation()


    return (
        <div className="BREIKKI-main-page-container">
            <div>
                {/* Welcome card */}
                <Row className="BREIKKI-main-page-welcome-card-container">
                    <Card className="BREIKKI-main-page-welcome-card">
                        <Card.Body>
                            <Card.Title><span className="BREIKKI-main-page-welcome-card-title">{t("main_page_welcome_card_title")}</span></Card.Title>
                            <Card.Text>{t("main_page_welcome_card_text")}</Card.Text>
                            <a className="BREIKKI-link" href="/about-us">{t("main_page_welcome_card_link")}</a>
                        </Card.Body>
                    </Card>
                </Row>
                <Row className="BREIKKI-main-page-row-content-row">
                    {/* News */}
                    <Col className="BREIKKI-main-page-row-content-col BREIKKI-main-page-row-content-col-news">
                        <Container className="BREIKKI-main-page-row-content-container BREIKKI-main-page-row-content-container-news">
                            <div className="BREIKKI-main-page-content-title-container">
                                <h2 className="BREIKKI-main-page-content-title">{t("news_title")}</h2>
                                <Icon news />
                            </div>
                            {news &&
                                news.slice()
                                    // TODO: move this sorting to backend once news has paging
                                    .sort((a, b) => new Date(b.article.createdDate) - new Date(a.article.createdDate))
                                    .map((n, i) => {
                                        const d = new Date(n.article.createdDate);
                                        // TODO: modify these stylings into proper css classes
                                        return (
                                            <Container
                                                className="BREIKKI-main-page-news"
                                                key={n._id}
                                            >
                                                <a
                                                    href={`/news/${n._id}`}
                                                    style={{
                                                        textDecoration: "none",
                                                        color: "inherit",
                                                        maxWidth: "100%",
                                                    }}
                                                >
                                                    <span className="BREIKKI-news-title" style={{ width: "70%", margin: 0 }}>
                                                        {n.article.title}
                                                    </span>
                                                    <div className="BREIKKI-news-content-container">
                                                        <pre className="BREIKKI-pre BREIKKI-main-page-summary" style={{ width: "70%", margin: 0 }}>
                                                            {n.summary}
                                                        </pre>
                                                        <pre
                                                            className="BREIKKI-pre"
                                                            style={{
                                                                margin: 0,
                                                                width: "30%",
                                                                marginLeft: "20px",
                                                                textAlign: "right",
                                                                paddingRight: "10px",
                                                                minWidth: "90px",
                                                            }}
                                                        >
                                                            {d.getDate()}.{d.getMonth() + 1}.{d.getFullYear()}
                                                        </pre>
                                                    </div>
                                                </a>
                                            </Container>
                                        );
                                    })}
                        </Container>
                    </Col>
                    {/* Upcoming events */}
                    <Col className="BREIKKI-main-page-row-content-col BREIKKI-main-page-row-content-col-events">
                        <Container className="BREIKKI-main-page-row-content-container">
                            <div className="BREIKKI-main-page-content-title-container">
                                <h2 className="BREIKKI-main-page-content-title">{t("upcoming_events_title")}</h2>
                                <Icon event />
                            </div>
                            {
                                upcomingEvents && upcomingEvents.length !== 0 ? (upcomingEvents.map((e, i) => <EventCard event={e} key={e._id} imageFirst={i % 2 === 0} />)) : (!loading && <p>{t("main_page_no_upcoming_events")}</p>)
                            }
                            <h2 className="BREIKKI-upcoming-events-subtitle" style={{ marginTop: "20px" }}>{t("upcoming_game_nights_title")}</h2>
                            {
                                gameNights && gameNights.length !== 0 ? gameNights.map((e) => <EventCard event={e} key={e._id} imageFirst={false} />) : (!loading && <p>{t("main_page_no_upcoming_game_nights")}</p>)
                            }
                            <a className="BREIKKI-main-page-content-all-events-link" href="/events">{t("main_page_all_events_link")}</a>
                        </Container>
                    </Col>
                </Row>
                <Row className="BREIKKI-main-page-divider">

                </Row>
                <Row className="BREIKKI-main-page-sponsors-row">
                    <h4 className="BREIKKI-main-page-sponsors-title">{t("main_page_sponsors_title")}</h4>
                    <Col>
                        <Container className="BREIKKI-main-page-sponsors-container">
                                <img
                                    className="BREIKKI-main-page-sponsor-logo"
                                    src={sponsor_logo1}
                                    alt="Clickable Tampereen Kielikoulu logo"
                                    onClick={() => window.open('https://www.tampereenkielikoulu.fi', '_blank')}
                                />
                                <img
                                    className="BREIKKI-main-page-sponsor-logo-rectangular"
                                    src={sponsor_logo2}
                                    alt="Clickable Biljardikauppa logo"
                                    onClick={() => window.open('https://www.biljardikauppa.fi', '_blank')}
                                />
                        </Container>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default MainPageBody
